import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services';

@Pipe({
  name: 'sdTranslate'
})
export class SdTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {
  }
  transform(value: string): string {
    return this.translateService.translate(value);
  }
}
